(() => {
  const boxes = document.querySelectorAll("[data-auction-api-url]");
  if (!boxes.length) return;

  const formatPrice = (price) => {
    const amount = Number(price?.amount);
    const currency = price?.currency || "PLN";

    if (Number.isNaN(amount)) return "--";

    return new Intl.NumberFormat("pl-PL", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const formatCountdown = (endsAt) => {
    if (!endsAt) return "--";

    const diffMs = new Date(endsAt).getTime() - Date.now();
    if (Number.isNaN(diffMs)) return "--";
    if (diffMs <= 0) return "Zakończona";

    const totalSeconds = Math.floor(diffMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const time = [hours, minutes, seconds]
      .map((value) => String(value).padStart(2, "0"))
      .join(":");
    return days > 0 ? `${days}d ${time}` : time;
  };

  const readSnapshot = (data) => data?.snapshot || data || {};

  const updateBox = (box, data) => {
    const snapshot = readSnapshot(data);
    const endsAt =
      snapshot.ends_at ||
      snapshot.end_at ||
      snapshot.endsAt ||
      snapshot.endTime;
    const biddersCount =
      snapshot.bidders_count ??
      snapshot.bidder_count ??
      snapshot.biddersCount ??
      snapshot.bidderCount;
    const currentPrice =
      snapshot.current_price || snapshot.currentPrice || snapshot.price;
    const updatedAt = data?.updated_at || data?.updatedAt;

    box.dataset.auctionEndsAt = endsAt || "";
    box.querySelector("[data-auction-price]").textContent =
      formatPrice(currentPrice);
    box.querySelector("[data-auction-bidders]").textContent =
      biddersCount == null ? "--" : String(biddersCount);
    box.querySelector("[data-auction-countdown]").textContent =
      formatCountdown(endsAt);
    box.querySelector("[data-auction-status]").textContent = "Na żywo";

    const updated = box.querySelector("[data-auction-updated]");
    if (updatedAt) {
      const updatedDate = new Date(updatedAt);
      updated.textContent = Number.isNaN(updatedDate.getTime())
        ? ""
        : `Ostatnia aktualizacja: ${updatedDate.toLocaleTimeString("pl-PL", { hour: "2-digit", minute: "2-digit" })}`;
    }
  };

  const refreshBox = async (box) => {
    const url = box.dataset.auctionApiUrl;
    if (!url) return;

    try {
      const response = await fetch(url, { cache: "no-store" });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      updateBox(box, await response.json());
    } catch (error) {
      box.querySelector("[data-auction-status]").textContent = "Brak danych";
      box.querySelector("[data-auction-updated]").textContent =
        "Nie udało się pobrać danych licytacji.";
      console.warn("Auction API request failed", error);
    }
  };

  boxes.forEach((box) => {
    refreshBox(box);
    window.setInterval(() => refreshBox(box), 15000);
  });

  window.setInterval(() => {
    boxes.forEach((box) => {
      box.querySelector("[data-auction-countdown]").textContent =
        formatCountdown(box.dataset.auctionEndsAt);
    });
  }, 1000);
})();
